/** UI `sectionKey` / option prefix → key on the `filters` object in the store */
export const SECTION_KEY_TO_FILTERS_FIELD = {
  status: 'status',
  language: 'language',
  type: 'type',
  channels: 'channels',
  tags: 'tags',
  campaigns: 'campaigns',
};

export function getSelectedKeysForFilterSection(filters, sectionKey) {
  const field = SECTION_KEY_TO_FILTERS_FIELD[sectionKey];
  if (field == null) {
    return [];
  }
  return filters?.[field];
}

import {
  CHANNEL,
  TEMPLATE_LANGUAGE,
} from '../../../../../features/templates/constants/messageTemplateKeys';
import { tenantHasLanguageChoice } from '../../../../../features/templates/lib/languageHelpers';

const TEXT_TAB_CHANNEL_KEYS = new Set([CHANNEL.SMS, CHANNEL.MMS]);

export function getResolvedChannelFilterOptions(activeTab, channelOptions) {
  if (String(activeTab) !== 'text') {
    return [];
  }
  return channelOptions.filter((opt) => TEXT_TAB_CHANNEL_KEYS.has(opt.key));
}

export function getResolvedLanguageFilterOptions(tenantAdditionalLanguages, languageOptions) {
  if (!tenantHasLanguageChoice(tenantAdditionalLanguages)) {
    return [];
  }

  const tenantLanguages = new Set([
    TEMPLATE_LANGUAGE.ENGLISH,
    ...(tenantAdditionalLanguages ?? []).map(String),
  ]);
  return languageOptions.filter((opt) => tenantLanguages.has(opt.key));
}

export function normalizeFilterSearchValue(value) {
  return String(value || '')
    .trim()
    .toLowerCase();
}

export function filterTagOptions(tags, normalizedSearchValue) {
  if (normalizedSearchValue.length < 3) {
    return tags;
  }

  return tags.filter((tag) =>
    String(tag?.label ?? '')
      .toLowerCase()
      .includes(normalizedSearchValue),
  );
}

export function getVisibleTagOptions({
  tags,
  normalizedSearchValue,
  tagsExpanded,
  collapsedCount = 5,
}) {
  const filteredTags = filterTagOptions(tags, normalizedSearchValue);

  if (normalizedSearchValue.length >= 3 || tagsExpanded) {
    return filteredTags;
  }

  return filteredTags.slice(0, collapsedCount);
}

export function buildFilterSections({
  activeTab,
  channelOptions,
  typeOptions,
  statusOptions,
  campaignOptions,
  languageOptions = [],
  tenantAdditionalLanguages = [],
}) {
  const resolvedChannelOptions = getResolvedChannelFilterOptions(activeTab, channelOptions);
  const resolvedLanguageOptions = getResolvedLanguageFilterOptions(
    tenantAdditionalLanguages,
    languageOptions,
  );
  return [
    ...(resolvedLanguageOptions.length > 0
      ? [{ sectionKey: 'language', title: 'Language', items: resolvedLanguageOptions }]
      : []),
    { sectionKey: 'status', title: 'Status', items: statusOptions },
    ...(String(activeTab) === 'text'
      ? [{ sectionKey: 'channels', title: 'Channels', items: resolvedChannelOptions }]
      : []),
    { sectionKey: 'type', title: 'Type', items: typeOptions },
    { sectionKey: 'campaigns', title: 'Campaigns', items: campaignOptions },
  ];
}

export function toggleOptionInSet(current, optionKey) {
  const next = new Set(current);
  if (next.has(optionKey)) {
    next.delete(optionKey);
  } else {
    next.add(optionKey);
  }
  return next;
}
